import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { requestChangeRules } from 'store/modules/rules/actions';
import { RootState } from 'types/store';

const mapStateToProps = (state: RootState) => ({
  index: state.rules.index,
  opacity: state.rules.opacity
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      changeItem: requestChangeRules
    },
    dispatch
  );

interface IRulesReduxState {
  readonly index: number;
  readonly opacity: boolean;
}

interface IRulesActions {
  changeItem: (index: number) => void;
}

export type WithRulesState = IRulesReduxState & IRulesActions;

const withRulesState = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withRulesState;



// WEBPACK FOOTER //
// ./src/enhancers/withRulesState.tsx